import { ResourceOptions } from 'react-admin';
import '../dataProvider';
import { Resources } from '../../resource';

// Data-only resource (rendered as a tab inside the Proxy Manager page; no route of its own).
export const name = Resources.proxyManagerProxies;
export const options: ResourceOptions = {
  label: 'resource.proxyManagerProxies',
};
